<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('hr.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0)">{{ $t('dailyActive.time3') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1)">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2)">{{ $t('dailyActive.time1') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 3}" @click="changeTimeType(3)">{{ $t('dailyActive.time2') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="math-box">
            <div class="math-title">{{$t('hr.range')}}</div>
            <div class="math-value" v-if="mathData.minData && mathData.maxData">
                {{mathData.minData ? mathData.minData : '--'}}-{{mathData.maxData ? mathData.maxData : '--'}}
                <span class="math-unit">{{$t('hr.unit')}}</span>
            </div>
            <div class="math-value" v-else>
                --
            </div>
        </div>
        <div class="math-box">
            <div class="math-title">{{$t('hr.avgHr')}}</div>
            <div class="math-value" v-if="mathData.avgData">
                {{mathData.avgData ? mathData.avgData : '--'}}
                <span class="math-unit">{{$t('hr.unit')}}</span>
            </div>
            <div class="math-value" v-else>
                --
            </div>
        </div>
        <div class="math-box">
            <div class="math-title">{{$t('hr.restingHr')}}</div>
            <div class="math-value" v-if="mathData.basicData">
                {{mathData.basicData ? mathData.basicData : '--'}}
                <span class="math-unit">{{$t('hr.unit')}}</span>
            </div>
            <div class="math-value" v-else>
                --
            </div>
        </div>
        <div class="cal-prop-box">
            <div class="prop-title">{{$t('hr.descTitle')}}</div>
            <div class="prop-content">{{$t('hr.desc')}}<br>{{$t('hr.desc1')}}
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr,
    changeMonthDate,
    GetYear,
    getDateWeek,
    getDateDay
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'rhythm',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 0,
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            yNum: 0,
            hrInfo: {},
            mathData: {},
            myChart: null,
            showLeftOpacity: 0,
            showRightOpacity: 1
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.startDate = getToday();
        this.endDate = getToday();
        this.time = getToday().slice(5, 10).replace(/-/g, '/');
        this.getData();
    },
    methods: {
        back() {
            this.$router.back()
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 3 && this.yNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) <= 2019) {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) > 2019) {
                this.yNum--;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && this.yNum < 0) {
                this.yNum++;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        changeTimeType(num) {
            this.activeTime = num;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 3) {
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        getData() {
            this.mathData = {}
            if (this.activeTime == 0) {
                this.$api.status.getHr({
                    type: 'heartRate',
                    date: this.startDate
                }).then(res => {
                    if (res.result == 1) {
                        if (res.info[0]) {
                            this.mathData.maxData = res.info[0].hrMax;
                            this.mathData.avgData = res.info[0].hrAvg;
                            this.mathData.minData = res.info[0].hrMin;
                            this.mathData.basicData = res.info[0].hrBasic;
                            this.hrInfo = res.info[0];
                        } else {
                            this.mathData.maxData = 0;
                            this.mathData.avgData = 0;
                            this.mathData.minData = 0;
                            this.mathData.basicData = 0;
                        }
                        this.$nextTick(function () {
                            this.drawDayChart()
                            this.$forceUpdate()
                        })
                    }
                })
            } else if (this.activeTime == 3) {
                let hrInfo;
                this.$api.status.queryHrDataByYear({
                    year: this.startDate,
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData.maxData = res.info.max;
                        this.mathData.avgData = res.info.avg;
                        this.mathData.minData = res.info.min;
                        this.mathData.basicData = res.info.basicHrAvg;
                        hrInfo = res.info;
                        this.hrInfo.dateArr = [];
                        this.hrInfo.dataMinArr = [];
                        this.hrInfo.dataMaxArr = [];
                        this.hrInfo.dataBasicArr = [];
                        for (let i = 0; i < hrInfo.hr.length; i++) {
                            this.hrInfo.dateArr.push(i + 1);
                            this.hrInfo.dataMinArr.push(hrInfo.hr[i].hrMin);
                            if (hrInfo.hr[i].hrMax == hrInfo.hr[i].hrMin && hrInfo.hr[i].hrMax > 0) {
                                this.hrInfo.dataMaxArr.push(0.9);
                            } else {
                                this.hrInfo.dataMaxArr.push(hrInfo.hr[i].hrMax - hrInfo.hr[i].hrMin);
                            }

                            this.hrInfo.dataBasicArr.push(hrInfo.hr[i].basicHrAvg);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            } else {
                let hrInfo;
                this.$api.status.getHr({
                    type: 'heartRate',
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData.maxData = res.info.maxHr;
                        this.mathData.avgData = res.info.avgHr;
                        this.mathData.minData = res.info.minHr;
                        this.mathData.basicData = res.info.avgBasicHr;
                        hrInfo = res.info;
                        this.hrInfo.dateArr = [];
                        this.hrInfo.dataMinArr = [];
                        this.hrInfo.dataMaxArr = [];
                        this.hrInfo.dataBasicArr = [];
                        for (let i = 0; i < hrInfo.dataHr.length; i++) {
                            let week = getDateWeek(hrInfo.dataHr[i].date);
                            let weekStr = this.$t('sleep.week' + week);
                            this.hrInfo.dateArr.push(weekStr + '\n' + getDateDay(hrInfo.dataHr[i].date));
                            this.hrInfo.dataMinArr.push(hrInfo.dataHr[i].hrMin);
                            if (hrInfo.dataHr[i].hrMax == hrInfo.dataHr[i].hrMin && hrInfo.dataHr[i].hrMax > 0) {
                                this.hrInfo.dataMaxArr.push(0.9);
                            } else {
                                this.hrInfo.dataMaxArr.push(hrInfo.dataHr[i].hrMax - hrInfo.dataHr[i].hrMin);
                            }
                            this.hrInfo.dataBasicArr.push(hrInfo.dataHr[i].hrBasic);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            }
        },
        drawDayChart() {
            let y = [[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2]]
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            if (!this.mathData.avgData) {
                this.myChart.setOption({
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 76 * this.ratio,
                        textStyle: {
                            fontFamily: 'SF',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            interval: 35,
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00']
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        axisLabel: false,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        }
                    },
                    series: [
                        {
                            data: [0, 0, 0],
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: 10,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            } else {
                let _this = this;
                this.myChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    tooltip: {
                        textStyle: {
                            fontFamily: "'D-D','SF'",
                        },
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ' + _this.$t('hr.unit') + '</div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            interval: 35,
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00']
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: this.hrInfo.hrData.split(','),
                            type: 'line',
                            showSymbol: false,
                            color: getSkin('--chart-color-3'),
                            smooth: true,
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(241, 74, 97, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(241, 74, 97, 0.70)',
                                    },
                                ]),
                            }
                        }
                    ]
                }, true);
            }
        },
        drawChart() {
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            let barWidth = 10 * this.ratio;
            if (this.activeTime == 1 || this.activeTime == 3) {
                barWidth = 10 * this.ratio;
            } else {
                barWidth = 4 * this.ratio;
            }
            if (!this.mathData.avgData) {
                this.myChart.setOption({
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 76 * this.ratio,
                        textStyle: {
                            fontFamily: 'SF',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: this.hrInfo.dateArr
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: false
                    },
                    series: [
                        {
                            name: '基础心率',
                            showSymbol: false,
                            itemStyle: {
                                color: getSkin('--chart-color-7'),
                            },
                            data: [0],
                            type: 'line',
                            lineStyle: {
                                width: 2,
                            }
                        }
                    ]
                }, true);
            } else {
                let _this = this;
                this.myChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    tooltip: {
                        textStyle: {
                            fontFamily: "'D-D','SF'",
                        },
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            let minData = params[1].data ? params[1].data : 0;
                            let maxData = params[2].data ? params[2].data : 0;
                            if (maxData == 0.9) {
                                maxData = 0
                            }
                            maxData = maxData + minData;
                            if (maxData == 0 && minData == 0) {
                                return
                            }
                            let html = '';
                            let arrIndex = item.axisValue - 1;
                            let monthArr = _this.$t('monthArr');
                            let month = _this.activeTime == 3 ? monthArr[arrIndex] : item.axisValue;
                            html += '<div style="font-size:13px;margin-bottom: 2px;color: ' + getSkin('--text-color-3') + '">' + month + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + minData + '~' + maxData + '</span> ' + _this.$t('hr.unit') + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ' + _this.$t('hr.unit') + '（' + _this.$t('hr.resting') + '）</div>'
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: this.hrInfo.dateArr
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            name: '基础心率',
                            showSymbol: false,
                            itemStyle: {
                                color: getSkin('--chart-color-7'),
                            },
                            data: this.hrInfo.dataBasicArr,
                            type: 'line',
                            lineStyle: {
                                width: 2,
                            },
                        },
                        {
                            name: '最低心率',
                            type: 'bar',
                            stack: 'Total',
                            silent: true,
                            itemStyle: {
                                borderColor: 'transparent',
                                color: 'transparent'
                            },
                            emphasis: {
                                itemStyle: {
                                    borderColor: 'transparent',
                                    color: 'transparent'
                                }
                            },
                            barWidth: barWidth,
                            data: this.hrInfo.dataMinArr
                        },
                        {
                            name: '心率',
                            type: 'bar',
                            stack: 'Total',
                            barWidth: barWidth,
                            itemStyle: {
                                color: getSkin('--chart-color-3'),
                                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                                borderRadius: [10, 10, 10, 10]
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-4')
                                }
                            },
                            data: this.hrInfo.dataMaxArr
                        },
                    ]
                }, true);
            }
        },
    },
}
</script>

<style scoped>
.content {
    padding-top: 96px;
}

.time-select {
    text-align: center;
    padding-top: 12px;
    position: relative;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#chart-box {
    height: 198px;
    width: 100%;
}

.chart-unit {
    position: absolute;
    font-size: 11px;
    color: var(--text-color-3);
    left: 15px;
    top: 30px;
}

.cal-prop-box {
    margin: 0 auto;
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
}

.prop-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin: 0px 15px 8px 16px;
    padding-top: 16px;
}

.prop-content {
    font-size: 13px;
    margin: 0 15px 0px 16px;
    color: var(--text-color-2);
    padding-bottom: 16px;
    line-height: 18px;
}

.math-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.math-title {
    font-size: 15px;
    margin-left: 16px;
}

.math-value {
    font-size: 20px;
    margin-right: 16px;
}

.math-unit {
    font-size: 13px;
    margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/34rhythm.vue